<chart-details-layout [chartDetails]="chartDetails"
                      [isLoading]="isLoading"
                      [showFormButtons]="showFormButtons"
                      (save)="onSaveSettings()"
                      (cancel)="onRevertSettings()">
    <users-removed-chart chart [showTitle]="false" [startDate]="null" [endDate]="null"></users-removed-chart>
    <base-details detailsComponent
                  *ngIf="!isLoading"
                  [chartDetails]="chartDetails"
                  [generalSettings]="config?.generalSettings"
                  (generalSettingsChange)="onGeneralSettingsChange($event)">
        <div #filterContent>
            <div class="row">
                <div class="col-lg-12">
                    <div class="form-group input-group has-feedback" style="position: relative;">
                        <label class="control-group input-group-addon" for="selectTimePeriod">
                            Time Period
                            <button class="info-btn"
                                    type="button"
                                    [attr.title]="info('timePeriod')"
                                    (click)="onInfoClick($event, 'timePeriod')">
                                i
                            </button>
                        </label>
                        <select id="selectTimePeriod"
                                name="selectTimePeriod"
                                [(ngModel)]="selectedTimePeriod"
                                class="form-control"
                                (click)="hideTooltip()">
                            <option value="" [selected]="selectedTimePeriod === ''">-- Select Time Period --</option>
                            <option *ngFor="let period of timePeriods" [value]="period.value">
                                {{ period.display }}
                            </option>
                        </select>

                        <div class="click-tooltip"
                             *ngIf="isTooltipVisible('timePeriod')"
                             (click)="hideTooltip()">
                            {{ info('timePeriod') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </base-details>
</chart-details-layout>